import { option } from 'fp-ts';
import {
  AcademicBackground,
  EmploymentSituationName,
  ContractType,
  MaritalStatus,
  UserInformation,
  CreditStudyId,
  UserId,
  DeclarationIncome,
  DeclarationRent,
  HasDependents,
  DateOfBirth,
  EmployerName,
  IncomingSource,
  CreditStudy,
} from './../../../domain';

export type UserInformationDto = {
  creditStudyId: string;
  userId: number;
  academicBackground: AcademicBackground;
  employmentSituation: EmploymentSituationName;
  declaredIncome: number;
  maritalStatus: MaritalStatus;
  declaresRent?: boolean;
  hasDependents?: boolean;
  dateOfBirth?: number;
  employerName?: string;
  contractType?: ContractType;
  incomingSource?: string;
};

export const UserInformationDto = {
  asDomain: (dto: UserInformationDto): UserInformation => ({
    creditStudyId: new CreditStudyId(dto.creditStudyId),
    userId: new UserId(dto.userId),
    academicBackground: dto.academicBackground,
    declaredIncome: new DeclarationIncome(dto.declaredIncome),
    maritalStatus: dto.maritalStatus,
    declaresRent: new DeclarationRent(!!dto.declaresRent),
    hasDependents: new HasDependents(!!dto.hasDependents),
    dateOfBirth: dto.dateOfBirth ? new DateOfBirth(dto.dateOfBirth) : undefined,
    employmentSituation: dto.employmentSituation,
    employerName: dto.employerName
      ? new EmployerName(dto.employerName)
      : undefined,
    incomingSource: dto.incomingSource
      ? new IncomingSource(dto.incomingSource)
      : undefined,
    contractType: dto.contractType,
  }),
};

export type CreditStudyResponseDto = {
  id: string;
  providedUserInfo: UserInformationDto;
};

export const CreditStudyResponseDto = {
  asDomain: (dto: CreditStudyResponseDto): CreditStudy => ({
    id: new CreditStudyId(dto.id),
    providedUserInfo: option.map(UserInformationDto.asDomain)(
      option.fromNullable(dto.providedUserInfo)
    ),
  }),
};
